import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import Dropdown from 'antd/lib/dropdown';
import Menu from 'antd/lib/menu';
import cn from 'clsx';

import { Button, Icons } from 'ui-kit';
import { User } from 'types';

import 'antd/lib/menu/style/css';
import 'antd/lib/dropdown/style/css';

import styles from './UserMenu.module.scss';

interface Props {
  className?: string;
  user: User;
  onLogout: () => void;
}

export function UserMenu({ className, user, onLogout }: Props) {
  const { t } = useTranslation('userMenu');
  const menu = useMemo(
    () => (
      <Menu>
        <Menu.Item>
          <Link to="/profile">{t('edit_profile')}</Link>
        </Menu.Item>
        <Menu.Item onClick={onLogout} className={styles.menuItem}>
          <Icons.SignOut />
          {t('log_out')}
        </Menu.Item>
      </Menu>
    ),
    [onLogout, t]
  );

  return (
    <Dropdown overlay={menu} trigger={['click', 'hover']}>
      <Button variant="link" className={cn(className, styles.userMenu)}>
        <span className="login">{user.Username}</span>
        <Icons.ArrowDrop />
      </Button>
    </Dropdown>
  );
}
